import { AdminAssessmentPaymentConstants } from './Admin/AdminAssessmentPaymentConstants';
import { AdminCounselerListConstants } from './Admin/AdminCouncelerListPageConstants';
import { AdminManageHospitalConstants } from './Admin/AdminManageHospitalPageConstants';
import { AdminManageUserConstants } from './Admin/AdminManageUserJoinPageConstants';
import { AdminVoucherListConstants } from './Admin/AdminVoucherListPageConstants';

// ! 수정 필요
export const clPatientInfoTableHeader = [
    { title: '날짜', type: 'date' },
    { title: '음식 섭취량 (kcal)', type: 'foodCalories' },
    { title: '운동 소모량 (kcal)', type: 'exerciseCalories' },
    { title: '수분 섭취량 (ml)', type: 'hydrate' },
    { title: '성공 여부', type: 'success' },
];

export const diagnosisListHeader = [
    { title: '이름', type: 'patientName' },
    { title: '생년월일', type: 'patientIdentityNumber' },
    { title: '학령/학기', type: 'gradeName' },
    { title: '연락처', type: 'patientMobile' },
    { title: '진료일시', type: 'diagnosisDateTime' },
    { title: '담당의', type: 'doctorName' },
    { title: '검사 항목', type: 'status' },
    { title: '', type: 'null' },
];

export const consultationListHeader = [
    { title: '이름', type: 'patientName' },
    { title: '생년월일', type: 'patientIdentityNumber' },
    { title: '학령/학기', type: 'gradeName' },
    { title: '연락처', type: 'patientMobile' },
    { title: '상담 일시', type: 'diagnosisDateTime' },
    { title: '담당자', type: 'doctorName' },
    { title: '진행 상태', type: 'status' },
    { title: '', type: 'null' },
];

export const adminDiagnosisListHeader = [
    { title: '소속병원', type: 'hospitalName' },
    { title: '이름', type: 'patientName' },
    { title: '생년월일', type: 'patientIdentityNumber' },
    { title: '학령/학기', type: 'gradeName' },
    { title: '연락처', type: 'patientMobile' },
    { title: '진료일시', type: 'diagnosisDateTime' },
    { title: '담당의', type: 'doctorName' },
    { title: '검사 항목', type: 'status' },
];
export const managingPatientsListHeader = [
    { title: '등록번호', type: 'regNum' },
    { title: '이름', type: 'name' },
    { title: '나이', type: 'age' },
    { title: '생년월일', type: 'identityNumber' },
    { title: '연락처', type: 'mobile' },
    { title: '마지막 진료일시', type: 'lastDiagnosisTimestamp' },
    { title: '총 진료 건수', type: 'allDiagnosisCount' },
    { title: '', type: 'null' },
];

export const adminManageUserListHeader = [
    { title: AdminManageUserConstants.paginationHeaderConstants.numbering, type: 'numbering' },
    { title: AdminManageUserConstants.paginationHeaderConstants.hospitalName, type: 'hospitalName' },
    { title: AdminManageUserConstants.paginationHeaderConstants.email, type: 'email' },
    { title: AdminManageUserConstants.paginationHeaderConstants.userName, type: 'name' },
    { title: AdminManageUserConstants.paginationHeaderConstants.phoneNumber, type: 'mobile' },
    { title: AdminManageUserConstants.paginationHeaderConstants.registrationTimestamp, type: 'registrationTimestamp' },
    { title: AdminManageUserConstants.paginationHeaderConstants.status, type: 'status' },
];

export const adminAssessmentPaymentListHeader = [
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.numbering, type: 'numbering' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.hospitalName, type: 'hospitalName' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.patientName, type: 'patientName' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.userTestingNo, type: 'userTestingNo' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.assessmentCode, type: 'assessmentCode' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.retailPrice, type: 'retailPrice' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.supplyPrice, type: 'supplyPrice' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.paymentDateTime, type: 'paymentDateTime' },
    { title: AdminAssessmentPaymentConstants.paginationHeaderConstants.isTest, type: 'isTest' },
];

export const adminManageHospitalListHeader = [
    { title: AdminManageHospitalConstants.paginationHeaderConstants.numbering, type: 'numbering' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.hospitalName, type: 'hospitalName' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.phoneNumber, type: 'phoneNumber' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.registrationTimestamp, type: 'registrationTimestamp' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.userCount, type: 'userCount' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.doctorCount, type: 'doctorCount' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.patientCount, type: 'patientCount' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.diagnosisCount, type: 'diagnosisCount' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.completedAssessmentCount, type: 'completedAssessmentCount' },
    { title: AdminManageHospitalConstants.paginationHeaderConstants.totalAmount, type: 'totalAmount' },
];

export const adminVoucherListHeader = [
    { title: AdminVoucherListConstants.paginationHeaderConstants.numbering, type: 'numbering' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.timestamp, type: 'timestamp' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.code, type: 'code' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.status, type: 'status' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.type, type: 'type' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.usedTimestamp, type: 'usedTimestamp' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.expiredTimestamp, type: 'expiredTimestamp' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.sendTimestamp, type: 'sendTimestamp' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.description, type: 'description' },
    { title: AdminVoucherListConstants.paginationHeaderConstants.sms, type: '' },
];

export const adminCounselerListHeader = [
    { title: AdminCounselerListConstants.paginationHeaderConstants.numbering, type: 'numbering' },
    { title: AdminCounselerListConstants.paginationHeaderConstants.hospitalName, type: 'hospitalName' },
    { title: AdminCounselerListConstants.paginationHeaderConstants.email, type: 'email' },
    { title: AdminCounselerListConstants.paginationHeaderConstants.userName, type: 'name' },
    { title: AdminCounselerListConstants.paginationHeaderConstants.phoneNumber, type: 'mobile' },
    { title: AdminCounselerListConstants.paginationHeaderConstants.schedule, type: '' },
];

export const viewDetailPatientListHeader = [
    { title: 'No.', type: 'order' },
    { title: '이름', type: 'name' },
    { title: '생년월일', type: 'identityNumber' },
    { title: '학령/학기', type: 'grade' },
    { title: '진료일시', type: 'diagnosisTimestamp' },
    { title: '담당의', type: 'doctorName' },
    { title: '검사 항목', type: 'status' },
    { title: '', type: 'null' },
];

export const ADMIN_CELL_INFO = {
    NUMBERING: 'numbering',
    HOSPITAL_NAME: 'hospitalName',
    CODE: 'hospitalCode',
    PATIENT_NAME: 'patientName',
    BIRTHDAY: 'patientBirth',
    TESTING_DATE: 'diagnosisDate',
    DOCTOR_NAME: 'doctorName',
    PSY_ITEM_ID: 'testCode',
    RETAIL_PRICE: 'retailPrice',
    SUPPLY_PRICE: 'supplyPrice',
};

export const CLManagingPatientsListHeader = [
    { title: '이름', type: 'name' },
    { title: '생년월일', type: 'birthday' },
    { title: '연락처', type: 'mobile' },
    { title: '칼로리랩 가입일', type: 'registrationTimestamp' },
    { title: '', type: 'null' },
];

export const CLManagingPatientsFavoriteListHeader = [
    { title: '오늘 진료', type: 'todayDiagnosis' },
    { title: '이름', type: 'name' },
    { title: '생년월일', type: 'birthday' },
    { title: '연락처', type: 'mobile' },
    { title: '칼로리랩 가입일', type: 'registrationTimestamp' },
    { title: '', type: 'null' },
];

export const CLUserLookupListHeader = [
    { title: '이름', type: 'name' },
    { title: '이메일', type: 'email' },
    { title: '연락처', type: 'mobile' },
    { title: '생년월일', type: 'birthday' },
    { title: '성별', type: 'gender' },
    { title: '칼로리랩 가입일', type: 'registrationTimestamp' },
    { title: '', type: 'null' },
];

export const todayDiagnosisListInHome = ['이름', '생년월일', '진료일시', '검사 항목'];

export const diagnosisListWidth = ['13%', '10%', '15%', '13%', '19%', '8%', '17%', '5%'];

export const managingPatientsListWidth = ['10%', '15%', '11%', '11%', '15%', '19%', '13%', '5%'];

export const adminManageUserListWidth = [92, 272, 348, 140, 164, 220, 204];

export const adminAssessmentPaymentListWidth = [60, 200, 160, 300, 240, 100, 100, 200, 120];

export const adminManageHospitalWidth = [92, 224, 160, 128, 124, 124, 136, 136, 136, 180];

export const viewDetailPatientListWidth = ['8%', '13%', '11%', '16%', '20%', '10%', '17%', '5%'];

export const todayDiagnosisListInHomeWidth = ['19%', '19%', '31%', '31%'];

export const adminDiagnosisListWidth = [248, 148, 140, 196, 176, 208, 124, 200];

export const adminVoucherListWidth = [10, 120, 80, 30, 40, 120, 120, 120, 100, 60];

export const adminCounselerListWidth = [20, 120, 120, 100, 100, 120];

export const clPatientInfoTableWidth = ['22%', '22%', '22%', '22%', '12%'];

export const clManagingPatientsListWidth = ['28%', '23%', '23%', '20%', '6%'];

export const clManagingPatientsFavoriteListWidth = ['7%', '22%', '22%', '22%', '21%', '8%'];

export const getCLManagingPatientsTableConfig = (showFavoriteButton: boolean) => {
    return {
        headers: showFavoriteButton ? CLManagingPatientsFavoriteListHeader : CLManagingPatientsListHeader,
        widths: showFavoriteButton ? clManagingPatientsFavoriteListWidth : clManagingPatientsListWidth,
    };
};

export const clUserLookupListWidth = ['16%', '24%', '17%', '15%', '10%', '14%', '4%'];
